const initialState = {
  fetching: false,
  fetched: false,
  items: [],
  error: null,
  nbResult: 0,
};
export const appsReducer = (state = initialState, action) => {
  switch(action.type) {
    case 'FETCH_APPS_FULFILLED': {
      const { data, nbResult } = action.payload.data;
      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        items: data,
        nbResult: nbResult
      };
      break;
    }
    case 'FETCH_APPS_PENDING': {
      return {...state, fetched: false, fetching: true};
      break;
    }
    case 'FETCH_APPS_REJECTED': {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          }
          break;
        default:
      }
      return {
        ...state,
        fetching: false,
        error
      };
      break;
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./app/reducers/index/apps.js